module.exports = __webpack_public_path__ + "img/SoundOffButtonNew.ed635e88.png";